import Axios from 'axios'
import {activityTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_activity_types (context) {
    Axios.get(activityTypeUrls.getAllActivityTypes).then(function (response) {
      context.commit('GET_ALL_ACTIVITY_TYPES', response.data)
    })
  },
  get_activity_types (context, publicId) {
    Axios.get(activityTypeUrls.getActivityTypes + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_TYPES', response.data)
    })
  },
  get_deleted_activity_types (context) {
    Axios.get(activityTypeUrls.getDeletedActivityType).then(function (response) {
      context.commit('GET_DELETED_ACTIVITY_TYPES', response.data)
    })
  },
  get_activity_type (context, publicId) {
    Axios.get(activityTypeUrls.getActivityType + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_TYPE', response.data)
    })
  },
  post_activity_type (context, data) {
    Axios.post(activityTypeUrls.postActivityType, data).then(function () {
      context.dispatch('get_all_activity_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_activity_type (context, data) {
    Axios.post(activityTypeUrls.editActivityType, data).then(function () {
      context.dispatch('get_all_activity_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_activity_type (context, data) {
    Axios.post(activityTypeUrls.deleteActivityType + data.public_id, data).then(function (response) {
      context.dispatch('get_all_activity_types')
    })
  },
  restoreActivityType (context, publicId) {
    Axios.get(activityTypeUrls.restoreActivityType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACTIVITY_TYPES', response.data)
      router.push({
        name: 'Module.ActivityTypes'
      })
    })
  }
}
